import { getPalette } from 'owa-theme';
import { IButtonStyles } from 'office-ui-fabric-react/lib/Button';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';

export default function getDiscardButtonStyle(colorScheme: ColorScheme): IButtonStyles {
    // Calculate the theme symbols from color scheme. Once Fabric's button supports IStyleOrFunctionObject,
    // we can wrap the button in a <Customizable> and get themeSymbols from function arg theme
    let defaultPalette = getPalette();
    return {
        root: {
            backgroundColor: defaultPalette.white,
            borderColor: defaultPalette.neutralLight,
        },
        rootHovered: {
            backgroundColor: colorScheme.calLighter,
        },

        rootPressed: {
            backgroundColor: colorScheme.calLight,
        },
    };
}
